export default __webpack_public_path__ + "static/media/shoes6.1329acb4.png";